import { IMondayContext } from '@/types/response/monday/context';
import { useAppQuery } from '.';
import { IEnvelopeDetails } from '@/types/response/envelope';
import { API_ROUTES } from '@/constants/api-routes';
import queryKeys from '@/constants/queryKeys';
import { UseQueryOptions } from 'react-query';
export const useGetEnvelopeQuery = (
  context?: IMondayContext,
  options?: UseQueryOptions<IEnvelopeDetails>,
) => {
  return useAppQuery<IEnvelopeDetails>({
    routeName: API_ROUTES.GET_ENVELOPE_OR_CREATE,
    queryKey: [
      queryKeys.ENVELOPE_CONFIG,
      context?.instanceId,
      context?.boardId,
    ],
    method: 'POST',
    requestConfig: {
      data: {
        instanceId: context?.instanceId,
        boardId: context?.boardId,
        accountId: Number(context?.account.id),
      },
      routeParams: {},
    },
    options: {
      enabled: !!context,
      refetchOnWindowFocus: false,
      ...options,
    },
  });
};
